export function decimalNumberFormatter(value: number, decimal = 0): string {
  if (value || value === 0) {
    const multiplier = Math.pow(10, decimal);
    const roundedValue = Math.round(value * multiplier) / multiplier;

    return String(roundedValue.toFixed(decimal));
  }

  return '';
}